import { useBreakpointValue } from '@chakra-ui/react';

export const useIsMobile = () => {
  const isMobile = useBreakpointValue([true, true, false]);
  return isMobile;
};
